import { styled } from "goober";
import { ClickButton } from "../ClickButton";
import { ButtonContent } from "./ButtonContent";
import { baseStyle, buttonClass, type ButtonStyle } from "./buttonStyle";

const Element = styled(ClickButton)`
  ${baseStyle}
`;

type Props = ButtonStyle &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> & {
    onClick?: (() => void) | React.MouseEventHandler<HTMLButtonElement>;
  };

export function Button({
  variant,
  size,
  icon,
  className,
  children,
  onClick,
  ...props
}: Props) {
  return (
    <Element
      {...props}
      onClick={onClick}
      className={buttonClass({ variant, size, icon, children, className })}
    >
      <ButtonContent size={size} icon={icon}>
        {children}
      </ButtonContent>
    </Element>
  );
}
